// routes/external-link.tsx
import { dynamic } from 'src/utils/ssr'

const getClientModule = () => import('src/clientRoutes/external-link')

export const handle = { name: 'external-link', track: { scene: 'external-link' } }

export default dynamic(getClientModule, { ssr: false })
